import { Button, FormatText, GridView, Widget } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, version } from 'antd';
import { getFechamentoControleRfaByFechamentoId } from '@app/api/fechamento';
import { CicloOrcamentarioRelatorio } from '@app/api/relatorioCicloorcamentario';
import TableBuilUp from '../Dashboard/Buildup/TableBuilUp';
const { Panel } = Collapse;


interface FechamentoControleRfaProps {
    fechamentoId: string;
}


const FechamentoControleRfa = (props: FechamentoControleRfaProps) => {

    const { fechamentoId } = props;

    const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CicloOrcamentarioRelatorio>();

    useEffect(() => {
        if (fechamentoId) {
            getFechamentoControleRfaByFechamentoId(fechamentoId).then((result) => {
                setCicloOrcamentarioRelatorioTotal(result);
            });
        }
    }, [fechamentoId]);

    return (

        <GridView noform>
            <Widget
                title="RESULTADO"
                span={12}
                actions={[]}>
                {cicloOrcamentarioRelatorioTotal ? (
                    <TableBuilUp
                        cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
                        paginacaoConfig={{ pageSize: 10 }}
                        relatorioControleRfa={true}
                        ocultarColunaDetalhe={true}
                    />
                ) :
                    (
                        <>
                        </>
                    )
                }

            </Widget>
        </GridView>

    );

}

export default FechamentoControleRfa;